export const getUtcOffsetHours = () => {
  return -new Date().getTimezoneOffset() / 60;
};
